import controller from './query-condition.controller';
import template from './query-condition.html';

export default {
	controller,
	template,
	bindings: {
		condition: '=ngModel',
		group:     '<group',
		disabled:  '<?ngDisabled',
	},
	require:  {
		ngModelCtrl:      '?ngModel',
		queryBuilder:     '^^?queryBuilder',
		queryBuilderChildren: '^^?queryBuilderChildren',
	},
};
